/* Kylmätekniikka Järvinen – teeman pienet toiminnot */
(function () {
  'use strict';

  function initMenu() {
    var toggle = document.querySelector('[data-kjp-menu-toggle]');
    var nav = document.querySelector('[data-kjp-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Sulje valikko' : 'Avaa valikko');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  function initCopyButtons() {
    document.querySelectorAll('[data-kjp-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-kjp-copy') || '';
        var label = btn.textContent;
        function flash(msg) { btn.textContent = msg; setTimeout(function () { btn.textContent = label; }, 1500); }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () { flash('Kopioitu'); }, function () { flash('Kopiointi estetty'); });
        } else {
          flash('Kopiointi estetty');
        }
      });
    });
  }

  function initForms() {
    document.querySelectorAll('form.kjp-form-card').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      });
    });
    var status = document.querySelector('[data-kjp-form-status]');
    if (status) {
      status.setAttribute('tabindex', '-1');
      status.focus();
      status.scrollIntoView({ block: 'center' });
    }
  }

  function initCartCount() {
    var el = document.querySelector('[data-kjp-cart-count]');
    if (!el || !window.fetch) return;
    document.addEventListener('cart:updated', function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { el.textContent = cart.item_count; })
        .catch(function () {});
    });
  }


  /* ---------- Tuotesivu: variantit, kuvat ja ostoskoriin lisäys ---------- */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('fi-FI', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function initProduct() {
    var root = document.querySelector('[data-kjp-product]');
    var dataEl = document.querySelector('[data-kjp-product-json]');
    if (!root) return;
    var data = null;
    try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { data = null; }
    var form = root.querySelector('form.kjp-pdp-form');
    var idInput = root.querySelector('[data-kjp-variant-id]');
    var priceEl = root.querySelector('[data-kjp-price]');
    var compareEl = root.querySelector('[data-kjp-compare]');
    var addBtn = root.querySelector('[data-kjp-add]');
    var addLabel = root.querySelector('[data-kjp-add-label]');
    var skuWrap = root.querySelector('[data-kjp-sku-wrap]');
    var skuEl = root.querySelector('[data-kjp-sku]');
    var availEl = root.querySelector('[data-kjp-availability]');
    var statusEl = root.querySelector('[data-kjp-status]');
    var mainMedia = root.querySelector('[data-kjp-main-media]');
    var thumbs = root.querySelectorAll('[data-kjp-thumb]');
    var selects = root.querySelectorAll('[data-kjp-option]');

    function showMedia(btn) {
      if (!btn || !mainMedia) return;
      var img = mainMedia.querySelector('img');
      if (img) {
        img.src = btn.getAttribute('data-src');
        img.srcset = btn.getAttribute('data-srcset');
        img.alt = btn.getAttribute('data-alt') || '';
      }
      thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn); });
    });

    function currentOptions() {
      var values = [];
      selects.forEach(function (sel) { values[Number(sel.getAttribute('data-kjp-option'))] = sel.value; });
      return values;
    }

    function update() {
      if (!data || !data.variants) return;
      var variant;
      if (!selects.length) {
        variant = data.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || data.variants[0];
      } else {
        var opts = currentOptions();
        variant = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Ei saatavilla';
        if (availEl) availEl.textContent = 'Tätä yhdistelmää ei ole saatavilla';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, data.currency);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.lastChild.textContent = formatMoney(variant.compare_at_price, data.currency);
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Lisää ostoskoriin' : 'Tilapäisesti loppu';
      if (availEl) availEl.textContent = variant.available ? 'Saatavilla' : 'Tilapäisesti loppu – kysy toimitusaikaa';
      if (skuWrap) skuWrap.hidden = !variant.sku;
      if (skuEl) skuEl.textContent = variant.sku || '';
      if (variant.media_id) {
        var t = root.querySelector('[data-kjp-thumb][data-media-id="' + variant.media_id + '"]');
        if (t) showMedia(t);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    selects.forEach(function (sel) { sel.addEventListener('change', update); });

    if (form && window.fetch && window.FormData) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.getAttribute('name') !== 'add') return;
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
        if (statusEl) { statusEl.classList.remove('is-error'); statusEl.textContent = 'Lisätään…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Virhe');
            if (statusEl) statusEl.innerHTML = 'Lisätty ostoskoriin. <a href="/cart">Siirry ostoskoriin</a>';
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function (err) {
            if (statusEl) { statusEl.classList.add('is-error'); statusEl.textContent = 'Lisääminen ei onnistunut: ' + err.message; }
          })
          .then(function () {
            if (addBtn) { addBtn.removeAttribute('aria-busy'); update(); }
          });
      });
    }
  }

  /* ---------- Kokoelma: järjestyksen vaihto ---------- */
  function initSort() {
    document.querySelectorAll('[data-kjp-sort] select').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- Saavutettavuus: vieritettävät taulukot näppäimistöllä ---------- */
  function initScrollableTables() {
    document.querySelectorAll('.kjp-table-wrap').forEach(function (wrap, i) {
      function update() {
        var scrollable = wrap.scrollWidth > wrap.clientWidth + 1;
        if (scrollable) {
          wrap.setAttribute('tabindex', '0');
          wrap.setAttribute('role', 'region');
          if (!wrap.getAttribute('aria-label')) {
            var heading = null, el = wrap.previousElementSibling;
            while (el && !heading) { if (/^H[2-4]$/.test(el.tagName)) heading = el; el = el.previousElementSibling; }
            wrap.setAttribute('aria-label', heading ? heading.textContent.trim() + ' (taulukko)' : 'Taulukko ' + (i + 1));
          }
        } else {
          wrap.removeAttribute('tabindex');
          wrap.removeAttribute('role');
        }
      }
      update();
      window.addEventListener('resize', update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMenu(); initCopyButtons(); initForms(); initCartCount(); initProduct(); initSort(); initScrollableTables(); });
  } else {
    initMenu(); initCopyButtons(); initForms(); initCartCount(); initProduct(); initSort(); initScrollableTables();
  }
})();
